export default __webpack_public_path__ + "static/media/14.47ae042e.webp";